import React from 'react';

const Products = () => {
  const products = [
    {
      id: 1,
      name: "Fast Connector SC/APC or SC/UPC",
      price: "Contact for pricing",
      rating: 5,
      reviews: "80+ terjual",
      description: "Professional Network Solutions",
      image: "/images/products/fastcon.png"
    },
    {
      id: 2,
      name: "Aksesoris Tiang",
      price: "Contact for pricing",
      rating: 4.9,
      reviews: "50+ terjual",
      description: "High Speed Connector",
      image: "/images/products/aksesoris-tiang.png"
    },
    {
      id: 3,
      name: "FAT Box: Aerial & Wall Conn SC/APC",
      price: "Contact for pricing",
      rating: 5,
      reviews: "19 terjual",
      description: "Enterprise Network Switch",
      image: "/images/products/fat16corelinknet.png"
    },
    {
      id: 4,
      name: "ODC 288 Core",
      price: "Contact for pricing",
      rating: 5,
      reviews: "3 terjual",
      description: "High Performance Converter",
      image: "/images/products/odc288c.png"
    },
    {
      id: 5,
      name: "Drop Cable",
      price: "Contact for pricing",
      rating: 4.8,
      reviews: "120+ terjual",
      description: "Signal Distribution Solution",
      image: "/images/products/dropcable.png"
    },
    {
      id: 6,
      name: "Roset",
      price: "Contact for pricing",
      rating: 4.7,
      reviews: "200+ terjual",
      description: "High Quality Patch Cord",
      image: "/images/products/roset.png"
    },
    {
      id: 7,
      name: "Patch Cord",
      price: "Contact for pricing",
      rating: 4.9,
      reviews: "15+ terjual",
      description: "Fiber Management System",
      image: "/images/products/patchcord.png"
    },
    {
      id: 8,
      name: "Splitter",
      price: "Contact for pricing",
      rating: 5,
      reviews: "5+ terjual",
      description: "Professional Splicing Tool",
      image: "/images/products/splitter.png"
    }
  ];

  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;
    
    for (let i = 0; i < fullStars; i++) {
      stars.push(<i key={i} className="fas fa-star"></i>);
    }
    
    if (hasHalfStar) {
      stars.push(<i key="half" className="fas fa-star-half-alt"></i>);
    }
    
    const emptyStars = 5 - Math.ceil(rating);
    for (let i = 0; i < emptyStars; i++) {
      stars.push(<i key={`empty-${i}`} className="far fa-star"></i>);
    }
    
    return stars;
  };

  // Carousel scroll logic
  const carouselRef = React.useRef(null);
  const scrollAmount = 400;

  const scrollLeft = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    }
  };
  const scrollRight = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  };

  return (
    <section id="products" className="products">
      <div className="container">
        <div className="section-header">
          <h2>Featured Products</h2>
          <p>Discover our top fiber optic products and solutions</p>
        </div>
        <div className="products-carousel-wrapper" style={{ position: 'relative', width: '100%' }}>
          <button className="carousel-arrow left" onClick={scrollLeft} aria-label="Scroll left" style={{ position: 'absolute', left: '-30px', top: '50%', transform: 'translateY(-50%)', zIndex: 2, background: '#8eea4d', border: 'none', borderRadius: '50%', width: '40px', height: '40px', fontSize: '1.5rem', color: '#fff', boxShadow: '0 2px 8px rgba(0,0,0,0.1)', cursor: 'pointer' }}>
            <span>&#8592;</span>
          </button>
          <div className="products-carousel" ref={carouselRef} style={{ display: 'flex', overflowX: 'auto', scrollBehavior: 'smooth', gap: '24px', padding: '10px 0' }}>
            {products.map((product) => (
              <div key={product.id} className="product-card" style={{ minWidth: '260px', maxWidth: '260px', flex: '0 0 auto' }}>
                <div className="product-image">
                  <img src={product.image} alt={product.name} />
                </div>
                <div className="product-info">
                  <h4>{product.name}</h4>
                  <div className="product-rating">
                    <div className="stars">
                      {renderStars(product.rating)}
                    </div>
                    <span className="rating-text">{product.rating} • {product.reviews}</span>
                  </div>
                  <p className="product-description">{product.description}</p>
                  <div className="product-price">{product.price}</div>
                  <button className="btn btn-outline">Contact for pricing</button>
                </div>
              </div>
            ))}
          </div>
          <button className="carousel-arrow right" onClick={scrollRight} aria-label="Scroll right" style={{ position: 'absolute', right: '-30px', top: '50%', transform: 'translateY(-50%)', zIndex: 2, background: '#8eea4d', border: 'none', borderRadius: '50%', width: '40px', height: '40px', fontSize: '1.5rem', color: '#fff', boxShadow: '0 2px 8px rgba(0,0,0,0.1)', cursor: 'pointer' }}>
            <span>&#8594;</span>
          </button>
        </div>
        <div className="products-footer">
          <button className="btn btn-primary">VIEW MORE PRODUCTS</button>
        </div>
      </div>
    </section>
  );
};

export default Products;